<template>
  <vcl-facebook v-if="loading"></vcl-facebook>
  <div v-else-if="!loading && result && result.id">
    <b-row>
      <b-col lg="12" xl="12">
        <b-card class="text-center" style="font-size:1.3em">
          <b-row>
            <b-col md="12">
              <h1> {{result.fqdn}} </h1>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Total Pages <br><small>(Page + External + Resource)</small> </label><br>
                <label for="ph_page">{{ result.page_count | number }} Numbers</label>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Inspection time</label>
                <br>
                (
                <b-badge variant="primary">
                  Total : {{moment(result.finished_at).diff(result.started_at, 'minutes') == 0 ? "< 1" : moment(result.finished_at).diff(result.started_at, 'minutes')}} min
                </b-badge>
                )
                <p>{{result.started_at | datetime}} ~ {{result.finished_at | datetime}}</p>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_detect_count" v-b-tooltip.hover>Detect Pages</label><br>
                <b-badge variant="danger" v-if="result.detect_count > 0"> {{result.detect_count}} Numbers </b-badge>
                <span v-else>-</span>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>Status</label><br>
                <b-badge v-if="result.finished_at" :variant="result.finished_at ? 'info' : 'light'"> {{result.finished_at ? 'Finished' : 'Scanning'}} </b-badge>
                <b-badge v-if="result.error_count > 0" variant="warning"> {{result.error_count ? 'Error' : 'Scanning'}} </b-badge>
                <br>
                <b-badge v-if="result.is_js" variant="info"> JS Event</b-badge>
                <div v-if="result.is_login">
                  <b-badge variant="info"> Logged in</b-badge>
                  <b-badge v-if="result.is_login_success" variant="success"> Login Successful</b-badge>
                  <b-badge v-else variant="warning"> Login Failed</b-badge>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="result.policy">
          <b-row v-if="result.policy">
            <b-col>
              <b-form-group>
                <label for="ph_links" v-b-tooltip.hover title="Enter the maximum sublink to navigate within a page. Ignore any excess links. Normally, if too many links exist on one page, you can reach the maximum navigation page before navigating to the other to prevent it from not being checked in a balanced way. You can specify it within the range of 1-1,000.">Sub Page Link
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_depth" v-model="result.policy.depth" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_limit" v-b-tooltip.hover title="Total number of pages to check on the inspection site. End the check when the entered number is reached. can be specified within the range of 1 to license limit.">Maximum Navigation Page
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_links" v-model="result.policy.links" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_depth" v-b-tooltip.hover title="Enter whether to check by moving (path) the link from the first page to the next. Can be specified within the range 1-100.">Maximum path depth
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_limit" v-model="result.policy.limit" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_timeout" v-b-tooltip.hover title="Time to wait for page loading. can be specified within the range of 1-30.">TimeOut(Second)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_timeout" v-model="result.policy.timeout" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group>
                <label for="ph_delay" v-b-tooltip.hover title="Time to wait before moving to a new page. can be specified within the range of 1 to 10,000.">Check Speed(Millisecond)
                  <span class="text-info">
                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </label>
                <b-form-input type="number" class="w-100 text-center" id="ph_delay" v-model="result.policy.delay" :plaintext="true"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col md="4" class="animated fadeIn fadeOut">
              <b-form-group>
                <label for="ph_count" v-b-tooltip.hover>ScreenShot</label><br>
                <img class="border" :src="image" :style="{ width: thumbnail_size }">
              </b-form-group>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>Site Check Summary</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_site" :series="data_site"></vue-apex-charts>
              </center>
            </b-col>
            <b-col md="4" class="animated fadeIn fadeOut mt-2">
              <center>
                <label for="ph_count" v-b-tooltip.hover>Percentage of resources</label><br>
                <vue-apex-charts class="mt-5" ref="_list" :width="thumbnail_size" type="donut" :options="options_resource" :series="data_resource"></vue-apex-charts>
              </center>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Detect List</strong> <small>Detect Pattern List {{result.detect_count | number}} Numbers ({{result.detect.start+(result.detect_count ? 1: 0)}} ~ {{result.detect.end | number}})</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.detect_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('detect')" ref="detect_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.detect.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
              <strong v-b-tooltip.hover title="Malicious code may be distributed under the guise of an error page Check for a recognized error page">
                Error Page
                <span class="text-info">
                  <i style="cursor:pointer" class="fas fa-question-circle"></i>
                </span>
              </strong>
              <small>List of Pages {{result.error_count || 0 | number}} 개 ({{result.error.start+(result.error_count ? 1 : 0)}} ~ {{result.error.end | number}})</small>
              <small v-if="result.error_count != result.error.end" class="pull-right">More displays when scrolling down</small>
            </div>
            <b-row>
              <b-col md="12">
                <pre v-if="result.error_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" ref="error_list">
                <pre v-if="error_list.length" slot="body" style="width: 3000px; overflow: visible;">{{result.error.data}}</pre>
                <pre v-else slot="body">
                  <template><div>No Data</div></template>
                </pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <strong>Page List</strong>
            <small>List of Pages {{result.page_count || 0 | number}} Numbers ({{result.page.start+(result.page_count ? 1 : 0)}} ~ {{result.page.end | number}})</small>
            <small v-if="result.page_count != result.page.end" class="pull-right">More displays when scrolling down</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.page_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('page')" ref="page_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.page.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>External Page</strong>
            <small>List of external site visits {{result.ext_count | number}} Number ({{result.ext.start+(result.ext_count ? 1 : 0)}} ~ {{result.ext.end | number}})</small>
            <small v-if="result.ext_count != result.ext.end" class="pull-right">More displays when scrolling down</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.ext_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('ext')" ref="ext_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.ext.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12" xl="12">
        <b-card>
          <div slot="header">
            <strong>Resource Data</strong>
            <small>Resource Data List {{result.resource_count | number}} Numbers ({{result.resource.start+(result.resource_count ? +1 : 0)}} ~ {{result.resource.end | number}})</small>
            <small v-if="result.resource_count != result.resource.end" class="pull-right">More displays when scrolling down</small>
          </div>
          <b-row>
            <b-col md="12">
              <pre v-if="result.resource_count === 0"><template><div>No Data</div></template></pre>
              <div v-else style="max-height: 300px; overflow: auto;" @scroll="scroll('resource')" ref="resource_list">
                <pre slot="body" style="width: 3000px; overflow: visible;">{{result.resource.data}}</pre>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
